import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
    html,
    body {
        padding: 0;
        margin: 0;
        font-family: "Gilroy", Arial, sans-serif;
    }

    * {
        box-sizing: border-box;
    }

    :root {
        --sat: 0px;
        --sab: 0px;
    }

    @supports (padding-top: env(safe-area-inset-top)) {
        :root {
            --sat: env(safe-area-inset-top);
            --sab: env(safe-area-inset-bottom);
        }
    }
    
    button {
        color: inherit;
        font: inherit;
        margin: 0;
        background: transparent;
        border: none;
        border-color: transparent;
        outline: none;
        padding: 0;
        appearance: none;
    }
`;
